import { ChevronDown, ChevronUp, Plus } from 'lucide-react';
import React, { useState } from 'react';
import AddGame from '../../components/Popup/AddGame';
import { useAuth } from '../../context/AuthContext';

export default function ManageHeader({ allGameSettings, refreshGames }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [adGamePopup, setAddGamePopup] = useState(false);

  const GAMES = ['Active', 'Inactive'];

  return (
    <>
      <div className='px-4 flex justify-between items-center'>
        <button
          className='px-2 py-2.5 bg-[#0E64D1] flex justify-center gap-2.5 text-xs text-white rounded-md font-normal'
          onClick={() => setAddGamePopup(true)}
        >
          <Plus className='w-4 h-4' />
          Add Game
        </button>

        <div>
          <div className='relative w-full'>
            <button
              id='dropdownButton'
              className='w-full p-2 text-xs font-normal text-gray-700 bg-white border rounded-md shadow-sm flex justify-between items-center '
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <span>{selectedStatus || 'Active'}</span>
              <span className='text-gray-500 ms-3'>
                {dropdownOpen ? (
                  <ChevronUp className='h-4 w-4' /> // ChevronUp icon for open state
                ) : (
                  <ChevronDown className='h-4 w-4' /> // ChevronDown icon for closed state
                )}
              </span>
            </button>
            {dropdownOpen && (
              <ul className='absolute left-0 z-10  w-full mt-1 bg-white border rounded-md shadow-md '>
                {GAMES.map((game, index) => (
                  <li
                    key={game}
                    onClick={() => {
                      setSelectedStatus(game);
                      setDropdownOpen(false);
                    }}
                    className={`p-2 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer flex justify-between items-center ${
                      index !== 0 ? 'border-t border-[#E1E7EF]' : ''
                    }`}
                  >
                    {game}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      <AddGame
        isOpen={adGamePopup}
        onClose={() => setAddGamePopup(false)}
        allGameSettings={allGameSettings}
        refreshGames={refreshGames}
      />
    </>
  );
}
